import { Point } from 'ui/quality-control/board/types';

// mirrors a point normalized to a segment's own box (0..1, see use-drawing.tsx) around that
// segment's actual center of symmetry, offset by `tiltFraction` (tiltOffset / segmentWidth)
// since a segment's right edge isn't flush with its left edge (see getPointsByShapeType in
// ui/quality-control/board/segment.tsx) — mirroring without this offset shifts the point by
// tiltFraction. This is a self-inverse point reflection: applying it twice is a no-op.
export const mirrorNormalizedPoint = (
  point: Point,
  tiltFraction: number,
): Point => ({
  x: 1 + tiltFraction - point.x,
  y: 1 - point.y,
});
